/* eslint-disable jsx-a11y/label-has-for */
import React from "react";
import {
  Button,
  Classes,
  Dialog,
  Intent,
  Spinner,
  Switch
} from "@blueprintjs/core";
import { Cell, Column, Table } from "@blueprintjs/table";
import { observer } from "mobx-react";
import classnames from "classnames";
import appState from "../stores/index";
import {
  requestChooseEdgeFile,
  requestChooseNodeFile,
  requestImportGraphFromCSV,
  requestCreateNewProject
} from "../ipc/client";
import Collapsable from "./utils/Collapsable";
import SimpleSelect from "./utils/SimpleSelect";
import { NODE_AND_EDGE_FILE, ONLY_EDGE_FILE } from "../constants/index";
import PostImportOptions from './PostImportOptions';

@observer
class PreviewTable extends React.Component {
  render() {
    const file = this.props.file;
    return (
      <Table
        className="import-preview-table"
        numRows={file.topN.length}
        selectedRegions={Object.values(file.mapping)
          .map(it => file.columns.indexOf(it))
          .map(it => ({ rows: null, cols: [it, it] }))}
      >
        {file.columns.map(it => (
          <Column
            key={it}
            name={it}
            renderCell={i => <Cell>{file.topN[i][it]}</Cell>}
          />
        ))}
      </Table>
    );
  }
}

@observer
class ImportDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      available: NODE_AND_EDGE_FILE,
      nodesOpen: true,
      edgesOpen: true,
      delimiter: ','
    };
  }

  changeAvailable = targetValue => {
    if (targetValue === ONLY_EDGE_FILE) {
      appState.import.importConfig.edgeFile.createMissing = true;
    }
    this.setState({ available: targetValue });
  };

  canImport = () => {
    if (this.state.available === NODE_AND_EDGE_FILE) {
      return (
        appState.import.importConfig.edgeFile.ready &&
        appState.import.importConfig.nodeFile.ready
      );
    } else if (this.state.available === ONLY_EDGE_FILE) {
      return appState.import.importConfig.edgeFile.ready;
    }
    return false;
  };

  renderNodesSelection = () => {
    const nodeFile = appState.import.importConfig.nodeFile;
    if (this.state.available === ONLY_EDGE_FILE) {
      return null;
    }
    return (
      <Collapsable
        name="Nodes"
        isOpen={this.state.nodesOpen}
        onToggle={() => this.setState({ nodesOpen: !this.state.nodesOpen })}
      >
        <div className={classnames(Classes.CONTROL_GROUP)} style={{ margin: "10px" }}>
          <div className={classnames(Classes.CONTROL_GROUP)}>
            <div style={{ lineHeight: "10px" }} className={classnames(Classes.INPUT_GROUP, Classes.FILL)}>
              <input
                type="file"
                className={classnames(Classes.DISABLED)}
                onChange={(event) => {
                  if (event.target.files.length < 1) {
                    return;
                  }
                  appState.import.selectedNodeFileFromInput = event.target.files[0];
                }}
              />
            </div>
          </div>
        </div>
        {/* <Switch
          label="Has Headers"
          checked={nodeFile.hasColumns}
          onChange={() => (nodeFile.hasColumns = !nodeFile.hasColumns)}
        /> */}
        {nodeFile.ready && (
          <div className="column-selection">
            <PreviewTable file={nodeFile} />
            Column for Node ID:
            <SimpleSelect
              items={nodeFile.columns}
              value={nodeFile.mapping.id}
              onSelect={it => (nodeFile.mapping.id = it)}
            />
            <p sytle={{ margin: '0 0 0px', padding: '0' }}></p>
            Column for Node Longitude:
            <SimpleSelect
              items={nodeFile.columns}
              value={nodeFile.mapping.LonX}
              onSelect={it => (nodeFile.mapping.LonX = it)}
            />
            <p sytle={{ margin: '0 0 0px', padding: '0' }}></p>
            Column for Node Latitude:
            <SimpleSelect
              items={nodeFile.columns}
              value={nodeFile.mapping.LatY}
              onSelect={it => (nodeFile.mapping.LatY = it)}
            />
          </div>
        )}
      </Collapsable>
    );
  };

  renderEdgesSelection = () => {
    const edgeFile = appState.import.importConfig.edgeFile;
    return (
      <Collapsable
        name="Edges"
        isOpen={this.state.edgesOpen}
        onToggle={() => this.setState({ edgesOpen: !this.state.edgesOpen })}
      >
        <div className={classnames(Classes.CONTROL_GROUP)} style={{ margin: "10px" }}>
          <div style={{ lineHeight: "10px" }} className={classnames(Classes.INPUT_GROUP, Classes.FILL)}>
            <input
              type="file"
              className={classnames(Classes.DISABLED)}
              onChange={(event) => {
                if (event.target.files.length < 1) {
                  return;
                }
                appState.import.selectedEdgeFileFromInput = event.target.files[0];
              }}
            />
          </div>
        </div>
        {/* <Switch
          label="Has Headers"
          checked={edgeFile.hasColumns}
          onChange={() => (edgeFile.hasColumns = !edgeFile.hasColumns)}
        /> */}
        {/* <Switch
          label="Create Missing Nodes"
          checked={edgeFile.createMissing}
          disabled={this.state.available === ONLY_EDGE_FILE}
          onChange={() => (edgeFile.createMissing = !edgeFile.createMissing)}
        /> */}
        {edgeFile.ready && (
          <div className="column-selection">
            <PreviewTable file={edgeFile} />
            Column for Source ID:
            <SimpleSelect
              items={edgeFile.columns}
              value={edgeFile.mapping.fromId}
              onSelect={it => (edgeFile.mapping.fromId = it)}
            />{" "}
            <br />
            Column for Target ID:
            <SimpleSelect
              items={edgeFile.columns}
              value={edgeFile.mapping.toId}
              onSelect={it => (edgeFile.mapping.toId = it)}
            />
            <Switch
              label="Weighted Graph"
              checked={appState.import.importConfig.edgeFile.isWeighted}
              onChange={() => {
                appState.import.importConfig.edgeFile.isWeighted = !appState.import.importConfig.edgeFile.isWeighted
                appState.graph.edges.isWeighted = !appState.graph.edges.isWeighted
              }}
            />

            {appState.import.importConfig.edgeFile.isWeighted && (
              <>
                Column for Edge Weight:
                <SimpleSelect
                  items={edgeFile.columns}
                  value={edgeFile.mapping.weight}
                  onSelect={it => (edgeFile.mapping.weight = it)}
                />
              </>
            )}

            <Switch
              label="Directed Graph"
              checked={appState.import.importConfig.edgeFile.isDirected}
              onChange={() => {
                appState.import.importConfig.edgeFile.isDirected = !appState.import.importConfig.edgeFile.isDirected
                appState.graph.edges.isDirected = !appState.graph.edges.isDirected
              }}
            />
          </div>
        )}
      </Collapsable>
    );
  };

  updateDelimiter(newDelimiter) {
    this.setState({ delimiter: newDelimiter });

    if (newDelimiter == "\\t") {
      newDelimiter = "\t"
    }

    appState.import.importConfig.edgeFile.delimiter = newDelimiter
    appState.import.importConfig.nodeFile.delimiter = newDelimiter
  }

  renderDelimiterSelection() {
    return (
      <div className="column-selection">
        Selected Delimiter:
        <SimpleSelect
          items={[",", "\\t", ";"]}
          value={this.state.delimiter}
          onSelect={it => { this.updateDelimiter(it) }}
        />{" "}
      </div>
    )
  }

  renderExampleDataset() {
    return (
      <div id="exampleTable" className={classnames(Classes.DIALOG_BODY)}>
        <p>Required attributes for nodelist.csv. Each row of the node table should represent attributes of a node, including at least a unique node ID and the node's longitude and latitude. </p>
        <table id="exampleNodeTable" className={Classes.TABLE} style={{ width: '100%' }}>
          <thead >
            <tr>
              <th > ID (unique node ID field) </th>
              <th> LonX (node longitude ) </th>
              <th> LatY (node latitude ) </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>"APL"</td>
              <td>67.2391</td>
              <td>-102.3472</td>
            </tr>

          </tbody>
        </table>
        <p>Required attributes for edgelist.csv. Each row of the edge table should represent attributes of an edge, including at least a source and target column corresponding to the node ID. </p>
        <table id="exampleEdgeTable" className={Classes.TABLE} style={{ width: '100%' }}>
          <thead>
            <tr>
              <th > Source </th>
              <th> Target </th>

            </tr>
          </thead>
          <tbody>
            <tr>
              <td>"APL"</td>
              <td>"FWL"</td>

            </tr>

          </tbody>
        </table>
        <p>Example Dataset:</p>
        <a target="_blank" rel="noopener noreferrer" className="pt-button pt-icon-document" href="https://drive.google.com/file/d/1_OIDSbUyM9gTqziVdcqU_NsGxkk6HMTo/view?usp=share_link"> US_airport_nodelist.csv</a>
        <a target="_blank" rel="noopener noreferrer" className="pt-button pt-icon-document" href="https://drive.google.com/file/d/1SOIgyAscyob6bUyeFIMiDVzSpfZVWDOt/view?usp=sharing"> US_airport_edgelist.csv</a>
      </div>
    )
  }

  render() {
    return (
      <Dialog
        iconName="import"
        className={classnames({
          [Classes.DARK]: appState.preferences.darkMode
        })}
        isOpen={appState.import.dialogOpen}
        onClose={() => {
          appState.import.dialogOpen = false;
        }}
        title="Import CSV"
      >
        {appState.import.loading ? (
          <Spinner />
        ) : (
          <div>
            <div className={classnames(Classes.DIALOG_BODY, "import-dialog")}>
              I have:
              <SimpleSelect
                items={[NODE_AND_EDGE_FILE]}
                value={this.state.available}
                onSelect={this.changeAvailable}
              />
              {this.renderNodesSelection()}
              {this.renderEdgesSelection()}
              {this.renderExampleDataset()}
              {/* {this.renderDelimiterSelection()} */}
              <hr />
              <PostImportOptions />
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button
                  className={classnames({
                    [Classes.DISABLED]: !this.canImport()
                  })}
                  intent={Intent.PRIMARY}
                  onClick={() => {
                    // TODO: this might be unsafe, check if there's racing condition

                    //active layout when new graph imported
                    appState.graph.runActiveLayout();

                    requestCreateNewProject({
                      name: appState.project.newProjectName,
                      createdDate: new Date().toLocaleString(),
                    });
                    requestImportGraphFromCSV( //edgefile.delimiter and nodefile.delimiter are the same
                      this.state.available === NODE_AND_EDGE_FILE, appState.import.importConfig.edgeFile.delimiter, appState.project.newProjectName
                    );

                    // Importing a graph means no label would be shown by default,
                    // thus turn off label CSSRenderer for better performance.
                    appState.graph.frame.turnOffLabelCSSRenderer();
                  }}
                  text="Import"
                />
              </div>
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}

export default ImportDialog;